import React, { useEffect, useState } from "react";
import socket from "../../assets/socketConnection";
import CheckoutItem from "../../containerSmall/checkoutItem/checkoutItem.component";
const CheckoutList = ({checkoutList}) => {
  return (
    <div className="transaction-list-container">
      {checkoutList?.map((item) => (
        <CheckoutItem key={item.id} {...item}/>
      ))}
    </div>
  );
};

export default CheckoutList;
